"use client"

import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { configs, DefaultImage } from "../../../../external-components"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import getClassNameFactory from "../../../lib/get-class-name-factory"
import { generateResponsiveCSS } from "../../../lib/helper"
import styles from "./css/styles.module.css"

const getClassName = getClassNameFactory("SimpleGrid", styles)

export interface SimpleGridProps extends CommonStylesProps {
  slides: {
    id?: number
    image?: string
    urlAppStore?: string
    urlGGStore?: string
    titleSlideItem?: string
    description?: string
  }[]
  imageHeight?: number
  imageWidth?: number
  imageBorderRadius?: number
  spaceBetween?: number
  slidesPerView?: number
  loop?: boolean
  speed?: number
  timeDelay?: number
  isPagination?: boolean
  isNavigation?: boolean
  autoPlay?: boolean
  pagination?: "default" | "custom"
  breakpoint?: []
}

export const RenderConfig: ComponentConfig<SimpleGridProps> = {
  render: ({ slides, styles, responsiveType, className, ...restProps }) => {
    const id = `simple-slider-${Math.random().toString(36).substr(2, 9)}`

    const mergedStyles = {
      mobile: { ...styles?.mobile },
      tablet: { ...styles?.tablet },
      desktop: { ...styles?.desktop },
    }

    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={`gridContainer ${twMerge(className)} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3`}>
          {slides.map(({ id, image, urlAppStore, urlGGStore, description, titleSlideItem }, index) => (
            <div data-aos="fade-up" data-aos-duration="1500" className="flex justify-center">
              <div
                key={index}
                className={`gridItem transition-transform duration-300 w-[300px] max-sm:w-[250px] ease-in-out transform rounded-[30px] overflow-hidden m-[12.5px] sm:m-5`}
                style={{ backgroundColor: "rgb(245, 245, 245)" }}
              >
                <img
                  src={image ? `${configs.API_URL}${image}` : DefaultImage}
                  alt={`Slide ${index}`}
                  className={`sm:h-[104px] sm:w-[104px] object-cover md:w-[300px] md:h-[300px] max-sm:w-[250px] max-sm:h-[250px]`}
                />
                <div className="text-center">
                  <h2 className="transition-transform duration-300 ease-in-out transform group-hover:text-[#3BC873] font-bold text-[15px] leading-[19px] pb-[10px] pt-[25px] sm:pt-[14px] px-2 tracking-[0.6px] sm:tracking-[0.72px] sm:text-[18px] sm:leading-[18px] text-[#3E3E3E]">
                    {titleSlideItem}
                  </h2>
                  <p className="text-[#535353] text-[13px] sm:text-[16px] font-normal leading-[20px] sm:leading-[24px] pb-[25px] sm:pb-[15px] pl-[19px] pr-[12px] sm:px-[10px]">
                    {description}
                  </p>
                </div>
                <div className="flex flex-row justify-evenly mb-[31px] sm:mb-[34px] px-0 sm:px-[12px]">
                  <a
                    href={urlAppStore}
                    target={urlAppStore ? "_blank" : ""}
                    rel="noopener noreferrer"
                    className="rounded-[7px]"
                  >
                    <img
                      src={`${configs.API_URL}/uploads/icon_appstore_1_3defc98501.png`}
                      className="rounded-[7px]"
                      alt="App Store"
                    />
                  </a>
                  <a
                    href={urlGGStore}
                    target={urlGGStore ? "_blank" : ""}
                    rel="noopener noreferrer"
                    className="rounded-[7px]"
                  >
                    <img
                      src={`${configs.API_URL}/uploads/icon_googleplay_1_9e0b2244c6.png`}
                      className="rounded-[7px]"
                      alt="App Store"
                    />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    )
  },
}
